export default {
  methods: {
    // 清空与Mo相关的vuex值 在MML.vue与RightPanel.vue中使用
    clearMoVuex() {
      this.changeMo({});
      this.changeCommand({});
      this.changeCmdMode(false);
      this.changeMassModMode(false);
      this.changeMassModExecingState(false);
      this.changeMmlOperButtonDisabled(false);
      this.changeMmlCmdButtonDisabled(false);
    },
  }
};